import React from "react";
import { Link } from "react-router-dom";
export function LenisEmblem({ size = 40, className = "" }) {
  return <img src="/brand/lenis-favicon.png" alt="LENIS Nutrition" width={size} height={size} className={className} style={{ objectFit: "contain" }} />;
}
export default function Logo({ className = "", testId = "nav-brand-logo", variant = "navbar" }) {
  return <Link to="/" aria-label="LENIS Nutrition home" data-testid={testId} className={`inline-flex shrink-0 items-center ${className}`}>
    <img src={variant === "full" ? "/brand/lenis-wordmark.png" : "/brand/lenis-horizontal.png"} alt="LENIS Nutrition" className={variant === "full" ? "w-48 h-auto" : "w-40 sm:w-48 h-auto"} />
  </Link>;
}
